<template>
  <!-- 创建和更新方案时，左侧方案编辑器 -->
  <div style="width:300px">
    <el-card :body-style="{ padding: '10px'}"
             style="margin-bottom:10px"
             shadow="never">
      <div> 选择出发日期：
        <el-date-picker v-model="selectBeginDate"
                        @change="selectDate"
                        style="width:65%"
                        size="mini"
                        type="date"
                        :clearable="false"
                        format="yyyy 年 MM 月 dd 日"
                        placeholder="选择日期">
        </el-date-picker>
      </div>
      <div>
        <el-button size="mini"
                   @click="addOneDayToTravelPlan"
                   style="width:100%;margin-top:10px">+增加一天</el-button>
      </div>
      <div>
        <el-button style="width:100%;margin-top:10px"
                   size="mini"
                   @click="saveTravelPlan"
                   type="primary">预览方案</el-button>
      </div>

    </el-card>
    <!-- ------------------------------------编辑方案-------------------------------------- -->
    <div v-if="plan_item_list.length == 0">
      <el-card shadow="never">请添加行程开始日期</el-card>
    </div>
    <div v-else>
      <el-card shadow="never"
               :body-style="activeCardStyle"
               v-for="item,index in plan_item_list"
               :key="index">
        <div>
          <!-- 天数、日期、星期、编辑中。。。 -->
          <div style="cursor:pointer;"
               @click="editorThisDayTrip(index)">
            <span class="day_number_style">第<span style="margin-left:5px">{{index+1}}</span>天</span>
            <span style="margin-left:10px">
              <!-- 日期 -->
              {{dateOfThisDate(index)}}
              <!-- 星期 -->
              <span v-if="dayOfThisDate(index)==1">星期一</span>
              <span v-if="dayOfThisDate(index)==2">星期二</span>
              <span v-if="dayOfThisDate(index)==3">星期三</span>
              <span v-if="dayOfThisDate(index)==4">星期四</span>
              <span v-if="dayOfThisDate(index)==5">星期五</span>
              <span v-if="dayOfThisDate(index)==6">星期六</span>
              <span v-if="dayOfThisDate(index)==0">星期日</span>
            </span>
            <span style="color:#ff5421; margin-left:30px"
                  v-if="activateEditorDay == index">编辑中...</span>
            <!-- 移除 天 -->
            <span style="font-size:20px;color:#ff5421;float:right;cursor:pointer">
              <i class="el-icon-remove"
                 @click="subDayTripFromTravelPlan(index)"></i>
            </span>
          </div>
          <!-- --------------------------v日行程迹点列表 【概览】 -------------------------- -->
          <div v-if="activateEditorDay !== index">
            <!-- 离开概览 -->
            <div v-if="item.departureTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item">
                <span class="day_trip_item_departure">离开 </span>
                <span class="day_trip_item_dest">{{item.departureTrip.dayTripInfo.dest}}</span>
                <!-- 显示错误提示 当前星期不在 running week ，者显示 不可用提示  -->
                <span style="margin-left:10px;color:red"
                      v-if="item.departureTrip.dayTripInfo.running_week.indexOf(dayOfThisDate(index))==-1">
                  ⚠️ 日期有冲突</span>

                <span class="day_trip_item_arrival_remove"
                      style="float:right">
                  <span style="margin-right:10px"
                        @click="saveDayTripAsNew(item,'departureTrip',index)">保存日行程</span>
                  <span @click="removeDayTripItem(item.departureTrip)">移除</span>
                </span>
              </div>
              <!-- 概览明细 -->
              <p v-for="item,index of  item.departureTrip.dayTripTraverList"
                 :key="index">
                <span v-if="'traver_title' in item">-> {{item.traver_title}}</span>
                <span v-else>-> 酒店：{{item.residence_name}}</span>
              </p>
            </div>
            <!-- 中转概览 -->
            <div v-if="item.transitTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item">
                <span class="day_trip_item_transit">中转 </span>
                <span class="day_trip_item_dest">{{item.transitTrip.dayTripInfo.dest}}</span>
                <!-- 显示错误提示 当前星期不在 running week ，者显示 不可用提示  -->
                <span style="margin-left:10px;color:red"
                      v-if="item.transitTrip.dayTripInfo.running_week.indexOf(dayOfThisDate(index))==-1">
                  ⚠️ 日期有冲突</span>
                <span class="day_trip_item_arrival_remove"
                      style="float:right">
                  <span style="margin-right:10px"
                        @click="saveDayTripAsNew(item,'transitTrip',index)">保存日行程</span>
                  <span @click="removeDayTripItem(item.transitTrip)">移除</span>
                </span>
              </div>
              <!-- 概览明细 -->
              <p v-for="item,index of  item.transitTrip.dayTripTraverList"
                 :key="index">
                <span v-if="'traver_title' in item">-> {{item.traver_title}}</span>
                <span v-else>-> 酒店：{{item.residence_name}}</span>
              </p>
            </div>
            <!-- 抵达概览 -->
            <div v-if="item.arrivalTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item">
                <span class="day_trip_item_arrival">抵达 </span>
                <span class="day_trip_item_dest">{{item.arrivalTrip.dayTripInfo.dest}}</span>
                <!-- 显示错误提示 当前星期不在 running week ，者显示 不可用提示  -->
                <span style="margin-left:10px;color:red"
                      v-if="item.arrivalTrip.dayTripInfo.running_week.indexOf(dayOfThisDate(index))==-1">
                  ⚠️ 日期有冲突</span>
                <span class="day_trip_item_arrival_remove"
                      style="float:right">
                  <span style="margin-right:10px"
                        @click="saveDayTripAsNew(item,'arrivalTrip',index)">保存日行程</span>
                  <span @click="removeDayTripItem(item.arrivalTrip)">移除</span>

                </span>
              </div>
              <!-- 概览明细 -->
              <p v-for="item,index of  item.arrivalTrip.dayTripTraverList"
                 :key="index">
                <span v-if="'traver_title' in item">-> {{item.traver_title}}</span>
                <span v-else>-> 酒店：{{item.residence_name}}</span>
              </p>
            </div>
            <!-- 整日概览 -->
            <div v-if="item.allDayTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item">
                <span class="day_trip_item_allday">整日 </span>
                <span class="day_trip_item_dest">{{item.allDayTrip.dayTripInfo.dest}}</span>
                <!-- 显示错误提示 当前星期不在 running week ，者显示 不可用提示  -->
                <span style="margin-left:10px;color:red"
                      v-if="item.allDayTrip.dayTripInfo.running_week.indexOf(dayOfThisDate(index))==-1">
                  ⚠️ 日期有冲突 </span>
                <span class="day_trip_item_arrival_remove"
                      style="float:right">
                  <span style="margin-right:10px"
                        @click="saveDayTripAsNew(item,'allDayTrip',index)">保存日行程</span>
                  <span @click="removeDayTripItem(item.allDayTrip)">移除</span> </span>
              </div>
              <!-- 概览明细 -->
              <p v-for="item,index of  item.allDayTrip.dayTripTraverList"
                 :key="index">
                <span v-if="'traver_title' in item">-> {{item.traver_title}}</span>
                <span v-else>-> 酒店：{{item.residence_name}}</span>
              </p>
            </div>
          </div>
          <!-- --------------------------日行程编辑【编辑中】-------------------------------- -->
          <div v-else>
            <!-- 离开 -->
            <div v-if="item.departureTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item_departure">离开 </div>
              <travel-plan-day-trip-style tripType="departureTrip"
                                          :index="index"
                                          @addResidence="addResidence"
                                          @addTraverPoint="addTraverPoint"
                                          @openTrafficEditor="openTrafficEditor"
                                          @deleteTraverPointFromDayTrip="deleteTraverPointFromDayTrip"
                                          @editTraverPointFromDayTrip="editTraverPointFromDayTrip"
                                          :dayTripTraverList="item.departureTrip.dayTripTraverList">
              </travel-plan-day-trip-style>
            </div>
            <!-- 中转 -->
            <div v-if="item.transitTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item_transit">中转 </div>
              <travel-plan-day-trip-style tripType="transitTrip"
                                          :index="index"
                                          @addResidence="addResidence"
                                          @addTraverPoint="addTraverPoint"
                                          @openTrafficEditor="openTrafficEditor"
                                          @deleteTraverPointFromDayTrip="deleteTraverPointFromDayTrip"
                                          @editTraverPointFromDayTrip="editTraverPointFromDayTrip"
                                          :dayTripTraverList="item.transitTrip.dayTripTraverList">
              </travel-plan-day-trip-style>
            </div>
            <!-- 抵达 -->
            <div v-if="item.arrivalTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item_arrival">抵达 </div>
              <!-- 日行程明细 -->
              <travel-plan-day-trip-style tripType="arrivalTrip"
                                          :index="index"
                                          @addResidence="addResidence"
                                          @addTraverPoint="addTraverPoint"
                                          @openTrafficEditor="openTrafficEditor"
                                          @deleteTraverPointFromDayTrip="deleteTraverPointFromDayTrip"
                                          @editTraverPointFromDayTrip="editTraverPointFromDayTrip"
                                          :dayTripTraverList="item.arrivalTrip.dayTripTraverList">
              </travel-plan-day-trip-style>

            </div>
            <!-- 整日 -->
            <div v-if="item.allDayTrip.dayTripTraverList.length!==0">
              <div class="day_trip_item_allday">整日 </div>
              <travel-plan-day-trip-style tripType="allDayTrip"
                                          :index="index"
                                          @addResidence="addResidence"
                                          @addTraverPoint="addTraverPoint"
                                          @openTrafficEditor="openTrafficEditor"
                                          @deleteTraverPointFromDayTrip="deleteTraverPointFromDayTrip"
                                          @editTraverPointFromDayTrip="editTraverPointFromDayTrip"
                                          :dayTripTraverList="item.allDayTrip.dayTripTraverList">
              </travel-plan-day-trip-style>
            </div>

          </div>
          <!-- --------------------------日行程结束编辑-------------------------- -->
        </div>
      </el-card>
      <el-button style="width:100%"
                 size="mini"
                 @click="saveTravelPlan"
                 type="primary">预览方案</el-button>
    </div>

  </div>
</template>

<script>
import TravelPlanDayTripStyle from '../../components/traver/TravelPlanDayTripStyle'
export default {
  name: 'travel-plan-editor',
  components: {
    TravelPlanDayTripStyle,
  },
  data() {
    return {
      selectBeginDate: this.beginDate,
      plan_item_list: this.planItemList,
      // 编辑激活
      activeCardStyle: { padding: '10px' }, // 默认样式
      activateEditorDay: this.editorDayIndex,
    }
  },
  props: {
    beginDate: {
      type: Date,
      default: () => {
        return new Date()
      },
    },
    editorDayIndex: Number,
    planItemList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    // planItemList(newVal) {
    //   console.log('sss', this.planItemList)
    //   this.plan_item_list = newVal
    // },
    planItemList: {
      handler(newValue) {
        // console.log('总', this.plan_item_list)
        this.plan_item_list = newValue
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 根据调整后的方案中的日行从，保存为新的日行程
    saveDayTripAsNew(item, trip_type, index) {
      // 获取到当前类型的日行程内容
      let newDayTrip = item[trip_type]
      // console.log(newDayTrip.dayTripInfo.dest_id)
      // console.log(newDayTrip)
      // 日行程数据 提取
      let postItem = {}
      postItem.trip_type = newDayTrip.dayTripInfo.trip_type
      postItem.trip_mode = newDayTrip.dayTripInfo.trip_mode
      postItem.remarkDayTrip = newDayTrip.dayTripInfo.remark
      postItem.dest = newDayTrip.dayTripInfo.dest_id
      postItem.recommend_time = newDayTrip.dayTripInfo.recommend_time
      // traverLIst
      let dayTripListPost = []

      newDayTrip.dayTripTraverList.forEach((i) => {
        console.log('i', i)
        // 遍历获取迹点的交通方案
        let i_traffic_plan_list = []
        if (i.TrafficPlan) {
          for (let item of i.TrafficPlan) {
            let traffic_item = {
              traffic_plan_id: item.traffic_plan_id,
              index: i.TrafficPlan.indexOf(item),
            }
            i_traffic_plan_list.push(traffic_item)
          }
        }
        // 遍历/添加 迹点 到列表
        if ('traver_title' in i) {
          let dayTripItem = {
            traver_id: i.id,
            traffic_id: i.traffic_id,
            traffic_plan: i_traffic_plan_list,
            index: newDayTrip.dayTripTraverList.indexOf(i),
          }
          dayTripListPost.push(dayTripItem)
        }
      })
      // console.log(dayTripListPost)
      postItem['dayTripList'] = dayTripListPost
      // 提交的数据
      // console.log(postItem)
      // return
      // 检查数据，发送请求保存日行程：

      this.$http.post('/traver/add_day_trip', postItem).then((res) => {
        if (res.data.errno == '0') {
          console.log(res)
          this.$message({
            message: res.data.errmsg,
            type: 'success',
          })
          let dayTripId = res.data.id
          this.$emit('creatNewDayTrip', dayTripId, index, trip_type)
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
      // 保存成功后返回给
    },
    saveTravelPlan() {
      console.log(this.plan_item_list)
      this.plan_item_list.forEach((day_item) => {
        // 判断各个类型的行程是否
      })
      this.$emit('saveTravelPlan')
    },
    selectDate(item) {
      // console.log('选择日期', item)
      this.$emit('selectBeginDate', item)
    },
    // 选中 需要[编辑]的日行程
    editorThisDayTrip(index) {
      if (this.activateEditorDay == index) {
        this.activateEditorDay = null
      } else {
        this.activateEditorDay = index
        this.$emit('activateEditorDay', index)
      }
    },
    // 添加迹点
    addTraverPoint(tripType, index) {
      this.$emit('addTraverPoint', tripType, index)
    },
    // 添加酒店
    addResidence(tripType, index) {
      this.$emit('addResidence', tripType, index)
    },
    // 编辑忌点
    editTraverPointFromDayTrip(tripType, index, item_index) {
      this.$emit('editTraverPointFromDayTrip', tripType, index, item_index)
    },
    // 移除日行程的迹点
    deleteTraverPointFromDayTrip(tripType, index, item_index) {
      this.$emit('deleteTraverPointFromDayTrip', tripType, index, item_index)
    },
    // 处理两点间交通
    openTrafficEditor(tripType, index, item, next_item) {
      this.$emit('openTrafficEditor', tripType, index, item, next_item)
    },

    // 当天日期
    dateOfThisDate(index) {
      // 获取所选的月份
      let year = this.selectBeginDate.getFullYear()
      let month = this.selectBeginDate.getMonth() + 1
      let date = this.selectBeginDate.getDate() + index
      // 判断 1\3\5\7\8\10\12
      // 如果当前月为12月
      if ([1, 3, 5, 7, 8, 10].indexOf(month) != -1) {
        if (date > 31) {
          let next_month = month + 1
          let new_day = date - 31
          return next_month + '月' + new_day + '日'
        } else {
          return month + '月' + date + '日'
        }
      } else if (month == 12) {
        if (date > 31) {
          let next_month = 1
          let next_year = year + 1
          let new_day = date - 31
          return next_month + '月' + new_day + '日'
        } else {
          return month + '月' + date + '日'
        }
      } else if (month == 2) {
        // 为2月份
        // console.log('2月')
        // 判断 闰年  平年
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
          // alert('您输入的年份是闰年')
          if (date > 29) {
            let next_month = month + 1
            let new_day = date - 29
            return next_month + '月' + new_day + '日'
          } else {
            return month + '月' + date + '日'
          }
        } else {
          // alert('您输入的年份是平年')
          if (date > 28) {
            let next_month = month + 1
            let new_day = date - 28
            return next_month + '月' + new_day + '日'
          } else {
            return month + '月' + date + '日'
          }
        }
      } else {
        // console.log('小月')
        if (date > 30) {
          let next_month = month + 1
          let new_day = date - 30
          return next_month + '月' + new_day + '日'
        } else {
          return month + '月' + date + '日'
        }
      }
    },
    // 获取当天星期
    dayOfThisDate(index) {
      // 获取所选的月份
      let year = this.selectBeginDate.getFullYear()
      let month = this.selectBeginDate.getMonth()
      let date = this.selectBeginDate.getDate() + index
      // 判断 1\3\5\7\8\10\12
      // 如果当前月为12月
      if ([1, 3, 5, 7, 8, 10].indexOf(month) != -1) {
        if (date > 31) {
          let next_month = month + 1
          let new_day = date - 31
          let new_date = new Date(year, next_month, new_day)
          return new_date.getDay()
        } else {
          let new_date = new Date(year, month, date)
          return new_date.getDay()
        }
      } else if (month == 2) {
        // 为2月份
        // console.log('2月')
        // 判断 闰年  平年
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
          // alert('您输入的年份是闰年')
          if (date > 29) {
            let next_month = month + 1
            let new_day = date - 29
            let new_date = new Date(year, next_month, new_day)
            return new_date.getDay()
          } else {
            let new_date = new Date(year, month, date)
            return new_date.getDay()
          }
        } else {
          // alert('您输入的年份是平年')
          if (date > 28) {
            let next_month = month + 1
            let new_day = date - 28
            let new_date = new Date(year, next_month, new_day)
            return new_date.getDay()
          } else {
            let new_date = new Date(year, month, date)
            return new_date.getDay()
          }
        }
      } else {
        if (date > 30) {
          let next_month = month + 1
          let new_day = date - 30
          let new_date = new Date(year, next_month, new_day)
          return new_date.getDay()
        } else {
          let new_date = new Date(year, month, date)
          return new_date.getDay()
        }
      }
    },
    // 增加一天 添加数据格式
    addOneDayToTravelPlan() {
      this.plan_item_list.push({
        departureTrip: {
          dayTripInfo: {},
          dayTripTraverList: [],
          remark: '',
        },
        transitTrip: {
          dayTripInfo: {},
          dayTripTraverList: [],
          remark: '',
        },
        arrivalTrip: {
          dayTripInfo: {},
          dayTripTraverList: [],
          remark: '',
        },
        allDayTrip: {
          dayTripInfo: {},
          dayTripTraverList: [],
          remark: '',
        },
      })
      // 改父组件的数据
      this.$emit('addOneDayToTravelPlan', this.plan_item_list)
    },
    // 减少一天
    subDayTripFromTravelPlan(index) {
      this.plan_item_list.splice(index, 1)
    },
    // 移除日行程
    removeDayTripItem(val) {
      val.dayTripTraverList = []
      val.dayTripInfo = {}
    },
  },
}
</script>

<style>
img {
  width: 100%;
}
.day_number_style {
  font-size: 20px;
  font-weight: 900;
  font-style: italic;
  color: #ff5421;
}

.setting_area_plan_day {
  background-color: cornsilk;
}

/* 模块 */
.day_trip_item_arrival_remove {
  display: none;
  cursor: pointer;
}
.day_trip_item:hover .day_trip_item_arrival_remove {
  display: block;
}

/* 样式 */
.day_trip_item_arrival {
  background-color: #163af3;
  font-weight: 900;
  color: #fff;
  padding: 0 5px;
  width: 10%;
}
.day_trip_item_allday {
  background-color: #ff5421;
  font-weight: 900;
  color: #fff;
  padding: 0 5px;
  width: 10%;
}

.day_trip_item_departure {
  background-color: green;
  font-weight: 900;
  color: #fff;
  padding: 0 5px;
  width: 10%;
}

.day_trip_item_transit {
  background-color: #ffc300;
  font-weight: 900;
  color: #fff;
  padding: 0 5px;
  width: 10%;
}
.day_trip_item_dest {
  padding-left: 5px;
  font-weight: 900;
  width: 10%;
}
</style>